import React from "react";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SearchIcon from '@mui/icons-material/Search';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import TranslateIcon from "@mui/icons-material/Translate";
import LogoutIcon from "@mui/icons-material/Logout";
import WideContainer from "./WideContainer";
import { Trans, withTranslation } from "react-i18next";
import { isDark, saveDark, applyTheme } from "../app/theme";
import { ensureCdnCookie } from "../app/cdnCookie";

import "./NavBar.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = { menuEl: null, dark: isDark() };
    this.openMenu = (e) => this.setState({ menuEl: e.currentTarget });
    this.closeMenu = () => this.setState({ menuEl: null });
    this.toggleDark = () => {
      const dark = !this.state.dark;
      saveDark(dark);
      this.setState({ dark });
      applyTheme(dark);
    };

    this.lngs = {
      en: { nativeName: "English" },
      fr: { nativeName: "Français" },
    };
  }

  componentDidMount() {
    // CDN cookie for the user's videos; it then keeps itself refreshed
    ensureCdnCookie();
    // dark mode only on pages built on the design tokens (`themed`); the rest stay light
    applyTheme(!!this.props.themed && this.state.dark);
    this.setDocTitle();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.themed !== this.props.themed) applyTheme(!!this.props.themed && this.state.dark);
    this.setDocTitle();
  }

  componentWillUnmount() {
    applyTheme(false);
    document.title = "VideoViews";
  }

  // the browser tab's title: `docTitle`, else the page title when it is text, then the app name
  setDocTitle() {
    const { docTitle, title, t } = this.props;
    const page = docTitle !== undefined ? docTitle : typeof title === "string" ? t(title) : "";
    const next = page ? page + " · VideoViews" : "VideoViews";
    if (document.title !== next) document.title = next;
  }

  render() {
    // wide: line up with a page in a WideContainer (library, search, project tabs)
    const Bar = this.props.wide ? WideContainer : Container;
    return (
      <div className="userBar">
        <div className="userBarNav">
          <Bar maxWidth="lg" className="userBarNavInner">
            <Link to="/" className="noUnderline">
              <div className="brand brandSm">VideoViews</div>
            </Link>

            <div className="navButtonsDiv">
              <Link to="/upload" className="noUnderline">
                <Button
                  className="Button ButtonPrimary navBtn"
                  size="small"
                  endIcon={<CloudUploadIcon />}
                >
                  <Trans>Upload</Trans>
                </Button>
              </Link>
              <Link to="/search" className="noUnderline">
                <Button
                  className="Button navBtn"
                  size="small"
                  endIcon={<SearchIcon />}
                >
                  <Trans>Search</Trans>
                </Button>
              </Link>
              <Link to="/ask" className="noUnderline">
                <Button
                  className="Button navBtn"
                  size="small"
                  endIcon={<QuestionAnswerIcon />}
                >
                  <Trans>Ask</Trans>
                </Button>
              </Link>
              {this.props.themed && (
                <button type="button" className="themeToggle" title={this.props.t("Toggle dark mode")} onClick={this.toggleDark}>
                  {this.state.dark ? <LightModeIcon /> : <DarkModeIcon />}
                  {this.state.dark ? <Trans>Light mode</Trans> : <Trans>Dark mode</Trans>}
                </button>
              )}
              <IconButton
                className="navAccount"
                size="small"
                title={this.props.t("Account")}
                aria-haspopup="true"
                aria-expanded={this.state.menuEl !== null ? "true" : undefined}
                onClick={this.openMenu}
              >
                <AccountCircleIcon />
              </IconButton>
              <Menu
                anchorEl={this.state.menuEl}
                open={this.state.menuEl !== null}
                onClose={this.closeMenu}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <MenuItem component={Link} to="/account/billing" onClick={this.closeMenu}>
                  <ManageAccountsIcon />
                  <Trans>Account</Trans>
                </MenuItem>
                {Object.keys(this.lngs)
                  .filter((lng) => this.props.i18n.language !== lng)
                  .map((lng) => (
                    <MenuItem
                      key={lng}
                      onClick={() => {
                        this.props.i18n.changeLanguage(lng);
                        this.closeMenu();
                      }}
                    >
                      <TranslateIcon />
                      {this.lngs[lng].nativeName}
                    </MenuItem>
                  ))}
                <Divider />
                <MenuItem component={Link} to="/logout" onClick={this.closeMenu}>
                  <LogoutIcon />
                  <Trans>Log Out</Trans>
                </MenuItem>
              </Menu>
            </div>
          </Bar>
        </div>
        {this.props.title !== "" && (
          <Bar maxWidth="lg" className="userBarTitle">
            <div className="pageTitle" title={this.props.title}>
              <Trans>{this.props.title}</Trans>{" "}
              <span className="pageSubtitle">{this.props.subtitle}</span>
            </div>
            <div className="userBarChildren" style={{ alignSelf: this.props.align }}>
              {this.props.children}
            </div>
          </Bar>
        )}
      </div>
    );
  }
}

export default withTranslation()(withRouter(Index));
